<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form>
                    <!--Forms-->
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Location-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select multiple
                                              v-model="locationId"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <!--Role-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Role :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select class=""
                                              v-model="roleId"
                                              name="roleId"
                                              id="roleData"
                                              label="text"
                                              @input="changedValueRole()"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="roleArr"
                                              placeholder="Select Role">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{roleError}}</font>
                                </div>
                            </div>
                            <!--Status-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="status">Status :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="status"
                                              name="status"
                                              id="status"
                                              label="text"
                                              @input="changeStatus()"
                                              :filterable="false"
                                              :options="statusArr"
                                              placeholder="Select Status">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{statusError}}</font>
                                </div>
                            </div>
                            <template v-if="sliderType == 'benefit' || sliderType == '401k'">
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label" for="locationType">Location Type :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <v-select v-model="locationType"
                                                  name="locationType"
                                                  id="locationType"
                                                  label="text"
                                                  :clearable="false"
                                                  :searchable="false"
                                                  :filterable="false"
                                                  :options="locationTypeArr"
                                                  placeholder="Select Location Type">
                                        </v-select>
                                    </div>
                                </div>
                            </template>
                            <!--Deascription-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea v-model="description" class="form-control"  type="text" id="description" placeholder="Description" ></textarea>
                                    <font class="text-danger">{{descriptionError}}</font>
                                </div>
                            </div>
                            <!--Slider Image-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Upload Image :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{imageError}}</font>
                                    <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="AddUpdateSlider()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="AddUpdateSlider(flag='Save and Continue')">
                                    <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="AddUpdateSlider()"></input>-->
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from 'vue';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import tinymce from 'vue-tinymce-editor';
    import axios from 'axios';

    Vue.use(VueCroppie);
    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                sliderType: '',
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 50, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg, .png, .gif, .bmp, .tiff",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

                imageType: [],
                imageSize: [],
                imagePath: [],
                imageWidth: 0,
                imageHeight: 0,
//                V-model
                description: '',
                locationId: '',
                locationArr: [],
                roleId: 0,
                roleArr: [],
                status: {value: 'active', text: 'Active'},
                statusArr: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'}
                ],
                pageTitle: '',

//                FrontEnd Errors
                locationError: '',
                statusError: '',
                roleError: '',
                imageError: '',
                descriptionError: '',
                isFileUploaded: false,
                fileUploaded: true,

//                BackEnd Error
                backendErrors: [],
            }
        },
        mounted: function () {
            self = this;
            self.checkLogin();
            self.showLoader();
            var path = window.location.pathname;
            var segments = path.split("/");

            self.sliderType = segments[3];
            self.loadLocationsAdd();
            self.loadRole();
            self.loadLocations();

            self.pageTitle = 'Add Slider (' + self.formatString(self.sliderType) + ')';



            if (segments[2] == 'updateslider') {
                self.pageTitle = 'Edit Slider (' + self.formatString(self.sliderType) + ')';
                if (segments[4]) {
                    self.loadSlider();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                }
            }

            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#roleId").on('keyup', function () {
                self.roleError = '';
            });
            $("#description").on('keyup', function () {
                self.descriptionError = '';
            });
            $("#videoTitle").on('keyup', function () {
                self.videoTitleError = '';
            });

            $("#drop1").on('change', function () {
                self.videoURLError = '';
            });

            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/

        },
        watch: {

        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listslider/' + self.sliderType);
            },

            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },

            vfileSuccess: function (file, response) {
                self.imagePath.push(response.content.media_path);
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imageType.push(file.type);
                self.imageSize.push(file.size);
                self.imageWidth = file.width;
                self.imageHeight = file.height;
                self.imageError = '';
                if (self.isFileUploaded == true && self.imageHeight % 225 != 0 || !(self.imageHeight >= 225) || !(self.imageHeight <= 450)
                        || self.imageWidth % 600 != 0 || !(self.imageWidth >= 600) || !(self.imageWidth <= 1200)) {
                    self.removeAllFiles();
                    self.imageError = "Please Upload Image In This Dimensions Only.(Height : 450 pixel, Width 1200 pixel)";
                }
            },

            removedSelectedFile(file, xhr, error) {
                var isManuallyAdded = (file.manuallyAdded === null || typeof (file.manuallyAdded) === "undefined" || file.manuallyAdded == '') ? false : file.manuallyAdded;
                if (self.imagePath.length <= 0) {
                    self.isFileUploaded = false;
                }
                if(!isManuallyAdded) {
                    var filePath = JSON.parse(file.xhr.response);
                    //console.log(file);
                    if ("media_thumb_path" in filePath.content) {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                    } else {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, "");
                    }
                    for (var i = self.imagePath.length - 1; i >= 0; i--) {
                        if (self.imagePath[i] === filePath.content.media_path) {
                            self.imagePath.splice(i, 1);
                            self.imageType.splice(i, 1);
                            self.imageSize.splice(i, 1);
                            self.imageHeight = 0;
                            self.imageWidth = 0;
                        }
                    }
                } else {
                    self.imagePath = [];
                    self.imageSize = [];
                    self.imageType = [];
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },

            changedValue: function (value) {
                //console.log(value);
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },

            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                self.showLoader();
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                self.roleArr.push(response.data.content[i]);
                            });
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                            self.hideLoader();
                        });
            },
            changedValueRole() {
                self.roleError = '';
            },
            changeStatus() {
                self.statusError = '';
            },

            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            self.locationArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            checkForm: function () {
                var checked = true;
                if (self.locationId.length === 0) {
                    /*if (!self.locationId) {*/
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.roleId) {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                }
//                if (!self.description) {
//                    self.descriptionError = "Description Required";
//                    if (checked) {
//                        checked = false;
//                    }
//                }
                if (self.isFileUploaded == false) {
                    self.imageError = "Please Upload Image";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.isFileUploaded == true && self.imageHeight % 225 != 0 || !(self.imageHeight >= 225) || !(self.imageHeight <= 450)
                        || self.imageWidth % 600 != 0 || !(self.imageWidth >= 600) || !(self.imageWidth <= 1200)) {
                    self.removeAllFiles();
                    self.imageError = "Please Upload Image In This Dimensions Only.(Height : 450 pixel, Width 1200 pixel)";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploaded == false) {
                    self.imageError = "Please Wait While Document Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.status) {
                    self.statusError = "Status Required";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },

            uploadManually(file) {
                if (self.imagePath.length > 0) {
                    var file_name = self.getFileName(self.imagePath[0]);
                    let file_type = self.getFileType(file_name);
                    let url = self.imagePath[0];
                    let file_size = self.imageSize[0];
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            AddUpdateSlider(flag) {
                /*console.log("Befor form check");*/
                self.checkForm();
                if (self.checkForm()) {
                    /*console.log("form check success");*/
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");
                    if (segments[2] == 'updateslider') {
                        if (segments[4]) {
                            var data = {
                                type: self.sliderType,
                                roleId: self.roleId.value,
                                locationId: locationsId,
                                location_type: self.locationType.value,
                                status: self.status.value,
                                mediaPath: self.imagePath[0],
                                mediaType: self.imageType[0],
                                mediaSize: self.imageSize[0],
                                description: self.description,
                                id: segments[4],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            type: self.sliderType,
                            roleId: self.roleId.value,
                            locationId: locationsId,
                            location_type: self.locationType.value,
                            status: self.status.value,
                            mediaPath: self.imagePath[0],
                            mediaType: self.imageType[0],
                            mediaSize: self.imageSize[0],
                            description: self.description,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }

                    self.showLoader();
                    HTTP.post("addupdateslider", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (segments[2] == 'updateslider') {
                                    if (segments[4]) {
                                        //console.log(segments[4]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.locationType = '';
                                        self.locationArr = [];
                                        self.roleId = '';
                                        self.roleArr = [];
                                        self.description = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.loadLocationsAdd();
                                        self.loadRole();
                                        self.loadLocations();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (segments[2] == 'updateslider') {
                                    if (segments[4]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            $(".alert-success").removeClass("hide");
                                            $(".alert-success").addClass("show");
                                            self.removeAllFiles();
                                            self.locationId = '';
                                            self.locationType = '';
                                            self.locationArr = [];
                                            self.roleId = '';
                                            self.roleArr = [];
                                            self.description = '';
                                            self.status = {value: 'active', text: 'Active'};
                                            self.loadLocationsAdd();
                                            self.loadRole();
                                            self.loadLocations();
                                            $("#status option[value='']").attr('selected', true);
                                            $("#type option[value='']").attr('selected', true);

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        $(".alert-success").removeClass("hide");
                                        $(".alert-success").addClass("show");
                                        self.removeAllFiles();
                                        self.locationId = '';
                                        self.locationType = '';
                                        self.locationArr = [];
                                        self.roleId = '';
                                        self.roleArr = [];
                                        self.description = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.loadLocationsAdd();
                                        self.loadRole();
                                        self.loadLocations();
                                        $("#status option[value='']").attr('selected', true);
                                        $("#type option[value='']").attr('selected', true);

                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            loadSlider() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[4],
                    type: self.sliderType,
                };
                self.showLoader();
                HTTP.post("getslider", data, config)
                        .then(function (response) {
//                        self.locationId = response.data.content[0].location_name;
                            /*self.locationId = {
                             value: response.data.content[0].location_id,
                             text: response.data.content[0].location_name,
                             };*/
                            self.locationId = [];
                            for (var i = 0; i < response.data.content[0].location.length; i++) {
                                self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                            }
                            self.locationType = {'text': self.formatString(response.data.content[0].location_type), 'value': response.data.content[0].location_type};
                            self.roleId = {
                                value: response.data.content[0].role_id,
                                text: response.data.content[0].role_name,
                            };
                            self.imagePath.push(response.data.content[0].image);
                            self.description = response.data.content[0].description;
                            if (response.data.content[0].status == 'active') {
                                self.status = {value: 'active', text: 'Active'};
                            } else {
                                self.status = {value: 'inactive', text: 'Inactive'};
                            }
                            /*console.log(self.videoTitle);*/

                            if (self.imagePath[0] != '') {
                                self.isFileUploaded = true;
                                self.imageSize.push(response.data.content[0].image_size);
                                self.imageWidth = 1200;
                                self.imageHeight = 450;
                                self.uploadManually();
                                //self.imagePath = '';
                            }
                            self.hideLoader();

                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            /*formatString: function (data) {
             var value = data.replace(/_/g, " ");
             var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
             return letter.toUpperCase();
             });
             return upp;
             },*/
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                value = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return value;
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.imageError = "";
                } else {
                    self.fileUploaded = false;
                }
            },
        }
    }
</script>

<style>
    /*.disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }*/
</style>



// WEBPACK FOOTER //
// src/components/backend/slider/AddSlider.vue